import { Component, ElementRef, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormControl, Validators, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';


@Component({
	selector: 'totp-input',
	templateUrl: './totp-input.component.html',
	styles: [ `
		.group3 {
			display: flex;
			flex-flow: row nowrap;
			gap: 1em;
			padding: 1em 0;
			margin: 0 1em;
		}
		.inputTotpChar {
			font-size: 25px;
			background-color: var(--customWhite);
			max-width: 1.5em;
			text-align: center;
			padding: .3em 0;
			border: 1px solid var(--sys-primary);
			border-radius: .3em;
		}
	`]
})
export class TotPInputComponent implements OnInit, OnDestroy {


	@Output() totpReady = new EventEmitter<{ totpCode: string, bAutoSend: boolean }>();


	codeCtrl1 = new UntypedFormControl( "", [ Validators.required ] );
	codeCtrl2 = new UntypedFormControl( "", [ Validators.required ] );
	codeCtrl3 = new UntypedFormControl( "", [ Validators.required ] );
	codeCtrl4 = new UntypedFormControl( "", [ Validators.required ] );
	codeCtrl5 = new UntypedFormControl( "", [ Validators.required ] );
	codeCtrl6 = new UntypedFormControl( "", [ Validators.required ] );
	totpForm = new UntypedFormGroup( {
		"code1": this.codeCtrl1,
		"code2": this.codeCtrl2,
		"code3": this.codeCtrl3,
		"code4": this.codeCtrl4,
		"code5": this.codeCtrl5,
		"code6": this.codeCtrl6,
	} );
	@ViewChild('inputTotp1') inputTotp1!: ElementRef;
	@ViewChild('inputTotp2') inputTotp2!: ElementRef;
	@ViewChild('inputTotp3') inputTotp3!: ElementRef;
	@ViewChild('inputTotp4') inputTotp4!: ElementRef;
	@ViewChild('inputTotp5') inputTotp5!: ElementRef;
	@ViewChild('inputTotp6') inputTotp6!: ElementRef;

	subscriptions = new Subscription();


	constructor() {}


	ngOnInit() {

		this.subscriptions.add(
			this.codeCtrl1.valueChanges.subscribe( v => { this.dealWithInput( v, this.codeCtrl1, this.inputTotp2 ); } )
		);

		this.subscriptions.add(
			this.codeCtrl2.valueChanges.subscribe( v => { this.dealWithInput( v, this.codeCtrl2, this.inputTotp3 ); } )
		);

		this.subscriptions.add(
			this.codeCtrl3.valueChanges.subscribe( v => { this.dealWithInput( v, this.codeCtrl3, this.inputTotp4 ); } )
		);

		this.subscriptions.add(
			this.codeCtrl4.valueChanges.subscribe( v => { this.dealWithInput( v, this.codeCtrl4, this.inputTotp5 ); } )
		);

		this.subscriptions.add(
			this.codeCtrl5.valueChanges.subscribe( v => { this.dealWithInput( v, this.codeCtrl5, this.inputTotp6 ); } )
		);

		this.subscriptions.add(
			this.codeCtrl6.valueChanges.subscribe( v => { this.dealWithInput( v, this.codeCtrl6, null ); } )
		);

		setTimeout( () => {
			this.inputTotp1?.nativeElement.focus();
		}, 10 );

	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}



	dealWithInput( str: string, ctrl: UntypedFormControl, inputToFocus: ElementRef | null ) {

		let bAutoSend = !inputToFocus;

		if( !str || !str.length ) str = "";
		str = str.trim();

		if( str ) {

			if( str.length == 6 ) {
				this.codeCtrl1.setValue( str[0], { emitEvent: false } );
				this.codeCtrl2.setValue( str[1], { emitEvent: false } );
				this.codeCtrl3.setValue( str[2], { emitEvent: false } );
				this.codeCtrl4.setValue( str[3], { emitEvent: false } );
				this.codeCtrl5.setValue( str[4], { emitEvent: false } );
				this.codeCtrl6.setValue( str[5], { emitEvent: false } );
				bAutoSend = true;
			}
			else {
				if( str.length > 1 ) ctrl.setValue( str[0], { emitEvent: false } );
				if( inputToFocus ) inputToFocus.nativeElement.focus();
			}
		}


		// timeout otherwise the form is still considered invalid
		setTimeout( () => {

			console.log( "this.totpForm.invalid", this.totpForm.invalid )
			if( this.totpForm.invalid ) return;

			const totpCode = this.codeCtrl1.value + this.codeCtrl2.value + this.codeCtrl3.value + this.codeCtrl4.value + this.codeCtrl5.value + this.codeCtrl6.value;
			this.totpReady.emit( { totpCode: totpCode, bAutoSend: bAutoSend } );
	
		}, 1 );

	}

}

